import { Button } from '@/components/button';

export type ErrorFallbackProps = {
  onReset: () => void;
};

export const ErrorFallback = ({ onReset }: ErrorFallbackProps) => {
  return (
    <div className="flex min-h-[calc(100vh-200px)] flex-col items-center justify-center gap-4">
      <h2 className="font-semibold text-2xl">Something went wrong!</h2>
      <Button
        aria-label="Try again to reload the page"
        onClick={onReset}
        size="lg"
        variant="primary"
      >
        Try again
      </Button>
    </div>
  );
};
